import axios from 'axios'

const DashboardService = {
  async getStatistics (params = {}) {
    return axios.get('ro/dashboard', { params })
  }
}

export default DashboardService
